/* Lucino product page: a jeweller's loupe over the photos, and the size and length guides. */
(() => {
  // the loupe follows the mouse over the photos; phones keep tap to zoom
  const gallery = document.querySelector('media-gallery');
  const fineMouse = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
  if (gallery && fineMouse) {
    const ZOOM = 2.6;
    const R = 140;
    const lens = document.createElement('div');
    lens.className = 'lxp-loupe';
    lens.hidden = true;
    document.body.append(lens);
    let shown = '';

    const hint = document.createElement('span');
    hint.className = 'lxp-loupe-hint';
    hint.textContent = 'För musen över bilden för att se stenarna';
    const first = gallery.querySelector('.media-gallery__grid > *');
    if (first) {
      if (getComputedStyle(first).position === 'static') first.style.position = 'relative';
      first.append(hint);
    }

    gallery.addEventListener('pointermove', (e) => {
      const item = e.target.closest?.('.media-gallery__grid > *');
      const img = item?.querySelector('img');
      if (!img || e.pointerType !== 'mouse') {
        lens.hidden = true;
        return;
      }
      const box = img.getBoundingClientRect();
      const nw = img.naturalWidth || 1;
      const nh = img.naturalHeight || 1;
      // the photo is object-fit: cover, so find where it really sits inside its box
      const scale = Math.max(box.width / nw, box.height / nh);
      const w = nw * scale;
      const h = nh * scale;
      const x = e.clientX - box.left - (box.width - w) / 2;
      const y = e.clientY - box.top - (box.height - h) / 2;
      const url = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
      if (url !== shown) {
        shown = url;
        lens.style.backgroundImage = `url("${url}")`;
      }
      lens.style.backgroundSize = `${w * ZOOM}px ${h * ZOOM}px`;
      lens.style.backgroundPosition = `${R - x * ZOOM}px ${R - y * ZOOM}px`;
      lens.style.transform = `translate(${e.clientX - R}px, ${e.clientY - R}px)`;
      lens.hidden = false;
    });
    gallery.addEventListener('pointerleave', () => {
      lens.hidden = true;
    });
  }

  // "Storleksguide" / "Längdguide" next to the option label; the picker re-renders on variant change, so put it back when needed
  const guides = [...document.querySelectorAll('[data-lxp-guide]')];
  if (guides.length) {
    const label = { storlek: 'Storleksguide', längd: 'Längdguide' };
    const place = () => {
      for (const legend of document.querySelectorAll('variant-picker fieldset legend')) {
        if (legend.querySelector('[data-lxp-open]')) continue;
        const text = legend.textContent.trim().toLowerCase();
        const guide = guides.find((g) => text.startsWith(g.dataset.lxpGuide));
        if (!guide) continue;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lxp-size__open';
        button.dataset.lxpOpen = guide.id;
        button.setAttribute('aria-haspopup', 'dialog');
        button.textContent = label[guide.dataset.lxpGuide];
        legend.appendChild(button);
      }
    };
    place();
    const info = document.querySelector('.product-information');
    if (info) new MutationObserver(place).observe(info, { childList: true, subtree: true });
    document.addEventListener('click', (e) => {
      const open = e.target.closest?.('[data-lxp-open]');
      if (open) {
        e.preventDefault();
        document.getElementById(open.dataset.lxpOpen)?.showModal();
        return;
      }
      if (e.target.matches?.('dialog.lxp-size')) e.target.close();
      if (e.target.closest?.('[data-lxp-close]')) e.target.closest('dialog').close();
    });
  }

  // "Välj silver / guld" under the close-ups picks the option and goes back up to the buy box
  document.addEventListener('click', (e) => {
    const b = e.target.closest?.('[data-lx-pick-metal]');
    if (!b) return;
    const value = b.getAttribute('data-lx-pick-metal');
    const input = [...document.querySelectorAll('variant-picker input[type="radio"]')].find((i) => i.value === value);
    if (input) input.click();
    document.querySelector('.product-information, main')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
